<template>
  <div class='questionnaire-container'>
    <div class="title">{{ $t(`${i18nPrefix}.title.onboardingQuestionnaire`) }}</div>
    <div class="question-answer-container">
      <template v-for="(question, index) in questionInfoList">
        <div class="question-answer-wrapper" :key="index">
          <div class="question-title">
            <a
              v-if="question.type === ONBOARDING_QUESTION_TYPE.LINK.value"
              class="link"
              target="_blank"
              :href="question.link"
            >{{ question.i18nTitle }}</a>
            <template v-else>{{ question.i18nTitle }}</template>
          </div>
          <div
            class="question-answer"
            v-loading="loading[question.id]"
            element-loading-spinner="el-icon-loading"
            :class="question.type === ONBOARDING_QUESTION_TYPE.ATTACHMENT.value && 'attachment link'"
            @click="handleAnswerClick(question)"
          >{{ question.answerValue || '-' }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { addI18nProperty, createI18nProperty } from '@/i18n'
import { ONBOARDING_QUESTION_TYPE } from '@/constant/common'
import { mapActions } from 'vuex'

const SELECT_TYPE = [
  ONBOARDING_QUESTION_TYPE.SINGLE.value,
  ONBOARDING_QUESTION_TYPE.LOCATION.value,
  ONBOARDING_QUESTION_TYPE.NATIONALITY.value,
  ONBOARDING_QUESTION_TYPE.COUNTRY.value,
  ONBOARDING_QUESTION_TYPE.PROVINCE.value,
  ONBOARDING_QUESTION_TYPE.CITY.value,
  ONBOARDING_QUESTION_TYPE.LANGUAGE.value
]

export default {
  props: {
    onboardingAnswers: {
      type: Array
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      ONBOARDING_QUESTION_TYPE,
      loading: {}
    }
  },
  computed: {
    questionInfoList () {
      const questionInfoList = _.map(this.onboardingAnswers, question => {
        addI18nProperty(question, 'i18nTitle', 'title.cn', 'title.en')
        const answer = question.answer
        const type = question.type
        if (type === ONBOARDING_QUESTION_TYPE.LINK.value) {
          addI18nProperty(question, 'link', 'options[0].content.cn', 'options[0].content.en')
          createI18nProperty(question, 'answerValue', `${this.i18nPrefix}.label.agreement.${answer === '1' ? 'agree' : 'disAgree'}`)
        } else if (SELECT_TYPE.includes(type)) {
          if (answer) {
            const option = _.find(question.options, { id: parseInt(answer) })
            addI18nProperty(question, 'answerValue', 'content.cn', 'content.en', option)
          }
        } else if (type === ONBOARDING_QUESTION_TYPE.ATTACHMENT.value) {
          createI18nProperty(question, 'answerValue', 'common.btn.view')
        } else {
          question.answerValue = answer
        }
        return question
      })
      return questionInfoList
    }
  },
  created () {

  },
  methods: {
    ...mapActions('common', ['getPrivateFileUrl']),
    async handleAnswerClick (question) {
      if (question.type !== ONBOARDING_QUESTION_TYPE.ATTACHMENT.value || !question.answer_file_key) {
        return
      }
      this.$set(this.loading, question.id, true)
      const fileUrl = await this.getPrivateFileUrl({ fileType: 'COMMON_FILE', fileKey: question.answer_file_key })
      this.$set(this.loading, question.id, false)
      window.open(fileUrl)
    }
  }
}
</script>
<style lang='scss' scoped>
.questionnaire-container {
  margin-top: 25px;
  font-size: 16px;

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #606266;
  }

  .question-answer-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 14px;
    margin-top: 30px;

    .question-answer-wrapper {
      width: 48%;
      margin-bottom: 16px;
      line-height: 20px;

      .policy {
        ::v-deep .el-checkbox__label {
          color: #0096CC;
        }

        ::v-deep .el-checkbox__input {
          &.is-checked {
            .el-checkbox__inner {
              background-color: #0096CC;
              border-color: #0096CC;
            }
          }
        }
      }

      .question-title {
        color: #303133;
        font-weight: bold;
      }

      .question-answer {
        margin-top: 3px;
        color: #606266;

        &.attachment {
          width: fit-content;
          color: #0096cc;
          padding: 0;
          cursor: pointer;

          ::v-deep .el-loading-mask {
            .el-loading-spinner {
              font-size: 18px;
              margin-top: -9px;
            }
          }
        }
      }
    }
  }
}
</style>
